import type { AxiosError } from 'axios';
import { useQuasar } from 'quasar';
import { t } from 'src/boot/i18n';
import { useRouter } from 'vue-router';

export function usePremiumAccessGuard() {
  const $q = useQuasar();
  const router = useRouter();

  function isPremiumAccessDenied(error: unknown): boolean {
    const response = (error as AxiosError)?.response;
    return response?.status === 403;
  }

  function handlePremiumAccessDenied(error: unknown): boolean {
    if (!isPremiumAccessDenied(error)) return false;

    $q.notify({
      type: 'warning',
      message: t('LICENSE_REQUIRED_REDIRECT_COURSES'),
    });

    window.setTimeout(() => {
      void router.push({ name: 'courses' });
    }, 700);

    return true;
  }

  return {
    isPremiumAccessDenied,
    handlePremiumAccessDenied,
  };
}
